export enum SurveyType {
    Top20 = 'TOP_20',
    Category = 'CATEGORY',
    SpecialProject = 'SPECIAL_PROJECT',
}

export const SURVEY_TYPE_OPTIONS = [
    { value: SurveyType.Top20, label: 'Top 20' },
    { value: SurveyType.Category, label: 'Category' },
    { value: SurveyType.SpecialProject, label: 'Special Project' },
] as const;

export const SURVEY_TYPE_LABELS: Record<SurveyType, string> = {
    [SurveyType.Top20]: 'Top 20',
    [SurveyType.Category]: 'Category',
    [SurveyType.SpecialProject]: 'Special Project',
};

export const SURVEY_TYPE_TO_IMPORT_TYPE: Record<SurveyType, string> = {
    [SurveyType.Top20]: 'TOP20',
    [SurveyType.Category]: 'CATEGORY_SURVEY',
    [SurveyType.SpecialProject]: 'SPECIAL_PROJECT_SURVEY',
};

export const SURVEY_IMPORT_TYPES = [
    'TOP20',
    'CATEGORY_SURVEY',
    'SPECIAL_PROJECT_SURVEY',
] as const;

export function getSurveyTypeLabel(
    surveyType?: string | null,
): string | undefined {
    if (!surveyType) return undefined;
    return (
        SURVEY_TYPE_LABELS[surveyType as SurveyType] ||
        surveyType.replace(/_/g, ' ')
    );
}

export function getSurveyBadgeLabel(
    surveyType?: string | null,
    label?: string | null,
): string | undefined {
    const typeLabel = getSurveyTypeLabel(surveyType);
    if (!typeLabel) return undefined;
    if (label && label !== typeLabel) {
        return `${typeLabel}: ${label}`;
    }
    return typeLabel;
}
